
// @ts-nocheck


export const localeCodes =  [
  "fr",
  "en"
]

export const localeLoaders = {
  fr: [
    {
      key: "locale_fr_46json_0bcb7f56",
      load: () => import("#nuxt-i18n/0bcb7f56" /* webpackChunkName: "locale_fr_46json_0bcb7f56" */),
      cache: true
    },
    {
      key: "locale_fr_46json_29465a71",
      load: () => import("#nuxt-i18n/29465a71" /* webpackChunkName: "locale_fr_46json_29465a71" */),
      cache: true
    },
    {
      key: "locale_fr_46json_b4654e51",
      load: () => import("#nuxt-i18n/b4654e51" /* webpackChunkName: "locale_fr_46json_b4654e51" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_c6f403bc",
      load: () => import("#nuxt-i18n/c6f403bc" /* webpackChunkName: "locale_en_46json_c6f403bc" */),
      cache: true
    },
    {
      key: "locale_en_46json_41d05ce3",
      load: () => import("#nuxt-i18n/41d05ce3" /* webpackChunkName: "locale_en_46json_41d05ce3" */),
      cache: true
    },
    {
      key: "locale_en_46json_68f14c74",
      load: () => import("#nuxt-i18n/68f14c74" /* webpackChunkName: "locale_en_46json_68f14c74" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "fr",
      iso: "fr-FR",
      name: "French",
      dir: "ltr",
      files: [
        {
          path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/form/dist/runtime/translations/fr.json",
          cache: undefined
        },
        {
          path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/list/dist/runtime/translations/fr.json",
          cache: undefined
        },
        {
          path: "/opt/actions-runner/_work/Apex/Apex/frontend/translations/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      iso: "en-US",
      name: "English",
      dir: "ltr",
      isCatchallLocale: true,
      files: [
        {
          path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/form/dist/runtime/translations/en.json",
          cache: undefined
        },
        {
          path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/list/dist/runtime/translations/en.json",
          cache: undefined
        },
        {
          path: "/opt/actions-runner/_work/Apex/Apex/frontend/translations/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "../translations/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: true,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: [
    {
      langDir: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/list/dist/runtime/translations",
      locales: [
        {
          code: "en"
        },
        {
          code: "fr"
        }
      ]
    },
    {
      langDir: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/form/dist/runtime/translations",
      locales: [
        {
          code: "en"
        },
        {
          code: "fr"
        }
      ]
    }
  ]
}

export const normalizedLocales = [
  {
    code: "fr",
    iso: "fr-FR",
    name: "French",
    dir: "ltr",
    files: [
      {
        path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/form/dist/runtime/translations/fr.json",
        cache: undefined
      },
      {
        path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/list/dist/runtime/translations/fr.json",
        cache: undefined
      },
      {
        path: "/opt/actions-runner/_work/Apex/Apex/frontend/translations/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    iso: "en-US",
    name: "English",
    dir: "ltr",
    isCatchallLocale: true,
    files: [
      {
        path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/form/dist/runtime/translations/en.json",
        cache: undefined
      },
      {
        path: "/opt/actions-runner/_work/Apex/Apex/frontend/node_modules/@paris-ias/list/dist/runtime/translations/en.json",
        cache: undefined
      },
      {
        path: "/opt/actions-runner/_work/Apex/Apex/frontend/translations/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/